import React from 'react';
import menuIconActive from "../assets/sidebaricons/menuIcon.svg";
const MenuActive = () => {
    return (
        <img src={menuIconActive} alt="menu" style={{ height: "16px" }} />
    )
}

export default MenuActive